<script lang="ts">
  import ActivityTypeDropdown from "../../components/Business/ActivityTypeDropdown.svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import DossierDropdown from "../../components/Business/DossierDropdown.svelte";
  // import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import TimeInput from "../../components/Form/Fields/TimeInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { activity, dossier, fetchDossier, fetchAtivityType, applyUserRevenue, cancelTimerActivity, saveTimerActivity } from "./timer.store";

  export let open: boolean = false;

  //const dispatch = createEventDispatcher();

  $: canSubmit = $activity != null && $activity.activityTypeId != null && ($activity.hours > 0 || $activity.minutes > 0);

  // $: hasDateSelection = !!$selection && !!$selection.dateKey;

  $: currentCustomerId = $activity != null ? $activity.customerId : 0;

  $: currentDossierTypeId = $dossier != null ? $dossier.dossierTypeId : 0;

  async function onDossierSelect(event: CustomEvent) {
    let item: IDropdownItem = event.detail;
    let _dossier = await fetchDossier(item.oid);
    dossier.set(_dossier);
    if (_dossier != null && _dossier.customerId != $activity.customerId) {
      $activity.customerId = _dossier.customerId;
    }
  }

  async function onActivityTypeSelect(event: CustomEvent) {
    let item: IDropdownItem = event.detail;
    if ($applyUserRevenue == false) {
      let _at = await fetchAtivityType(item.oid);
      if (_at != null && $activity != null) {
        $activity.hourlyRevenue = _at.hourlyRevenue;
      }
    }
  }

  function handleConfirmClick(event: Event) {
    saveTimerActivity($activity);
    //open = false;
    //dispatch("confirm", event);
  }

  function handleDeclineClick(event: Event) {
    cancelTimerActivity();
    //open = false;
    //dispatch("decline", event);
  }
</script>

{#if open && !!$activity}
  <div class="modal is-active">
    <div class="modal-background" />

    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Creazione attività</p>

        <button class="delete" aria-label="close" on:click={handleDeclineClick} />
      </header>

      <section class="modal-card-body">
        <!--
        <FormField>
          <DateInput name="Data" placeholder="data" small={true} bind:value={$activity.date} />
        </FormField>
      -->
        <FormField>
          <CustomerDropdown name="Cliente" small={true} required={false} bind:value={$activity.customerId} on:select={($activity.dossierId = null)} />
        </FormField>
        <FormField>
          <ActivityTypeDropdown
            name="Causale Attività"
            required={true}
            small={true}
            dossierTypeId={currentDossierTypeId}
            bind:value={$activity.activityTypeId}
            on:select={onActivityTypeSelect}
          />
        </FormField>
        <FormField>
          <Input name="Descrizione aggiuntiva" placeholder="descrizione aggiuntiva" small={true} required={false} bind:value={$activity.title} />
        </FormField>
        <FormField>
          <DossierDropdown
            name="Pratica"
            required={false}
            small={true}
            customerId={currentCustomerId}
            bind:value={$activity.dossierId}
            on:select={onDossierSelect}
          />
        </FormField>
        <!--
        <FormField>
          <PortalUserDropdown
            name="Utente"
            required={true}
            small={true}
            bind:value={$activity.portalUserId}
          />
        </FormField>
        -->

        <div>
          <div class="columns">
            <div class="column">
              <FormField>
                <TimeInput name="Tempo (Ore : Minuti)" required={true} small={true} bind:hours={$activity.hours} bind:minutes={$activity.minutes} />
              </FormField>
            </div>
            <div class="column">
              <FormField>
                <NumberInput name="Ricavo orario" placeholder="ricavo orario" required={true} small={true} bind:value={$activity.hourlyRevenue} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <FormField>
                <NumberInput
                  name="Costi anticipati"
                  placeholder="costi anticipati"
                  disabled={$activity.costs == 0}
                  required={false}
                  small={true}
                  bind:value={$activity.costsAmount}
                />
              </FormField>
            </div>
            <div class="column is-3">
              <FormField klass="has-text-centered">
                <Switch name="Costi" condensed={true} bind:value={$activity.costs} on:toggle={(_) => ($activity.costsAmount = 0)} />
              </FormField>
            </div>
            <div class="column is-3">
              <FormField klass="has-text-centered">
                <Switch name="Fatturata" condensed={true} bind:value={$activity.billed} />
              </FormField>
            </div>
          </div>
        </div>
        <FormField>
          <Textarea name="Note" placeholder="note" required={false} small={true} rows={2} bind:value={$activity.notes} />
        </FormField>

        <!--
        <div class="activity-controls has-text-centered">
          <Button klass="is-primary" disabled={!canSubmit} on:click={onSaveActivity}>Salva</Button>
          <Button klass="is-light" on:click={onCancelActivity}>Annulla</Button>
        </div>
      -->
      </section>

      <footer class="modal-card-foot modal-confirm-modal-card-foot">
        <button class="button is-primary" disabled={canSubmit == false} on:click={handleConfirmClick}>Crea attività</button>
        <button class="button" on:click={handleDeclineClick}>Annulla</button>
      </footer>
    </div>
  </div>
{/if}

<style>
  .modal-confirm-modal-card-foot {
    display: inline-block;
    text-align: center;
  }
</style>
